




























import { InstrumentStatus, SelectedInstrument } from "@/shared/types";
import {
  Vue,
  Component,
  Prop,
} from "@/shared/vuepack";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import InstrumentName from "@/shared/components/investments/drivewealth/InstrumentName.vue";
import { useDrivewealthSweepStore } from "@/shared/store/drivewealthSweep";
import { useDrivewealthStore } from "@/shared/store/drivewealth";

export interface InstrumentSearchResult {
  instrument: { symbol: string, companyName: string, website: string, imageUrl: string };
  status: string;
  action: SelectedInstrument;
}

@Component({
  components: {
    GenericLoadingSpinner,
    InstrumentName,
  }
})
export default class InstrumentSearchResultsTable extends Vue {
  @Prop({ required: true })
  detailItems: InstrumentSearchResult[];

  @Prop({ required: true })
  showBusyState: boolean;
  drivewealthStore = useDrivewealthStore();
  drivewealthSweepStore = useDrivewealthSweepStore();

  isDisabled (instrumentDetail: SelectedInstrument): boolean {
    return !this.drivewealthSweepStore.isActive
        || this.drivewealthSweepStore.isAlreadySelected(instrumentDetail.stockSymbol)
        || instrumentDetail.status !== InstrumentStatus.Active;
  }

  detailFields = [
    {
      key: "instrument",
      thClass: "text-left pl-2",
      tdClass: "pl-2",
      label: "Instrument"
    },
    {
      key: "status",
      label: "Status",
      thClass: "text-center",
      tdClass: "text-center"
    },
    {
      key: "action",
      label: "",
      thClass: "text-center"
    },
  ];
}
